const editorialAuthor = {
  username: "AGM Editorial",
  email: "editorial@avdheshanandgmission.org",
};

const sources = {
  prabhuLife: {
    label: "Prabhu Premi Sangh - Life Sketch",
    url: "https://www.prabhupremisangh.org/web/pages/life_sketch.html",
    note: "Swami ji's public life, Juna Akhara role, Vedantic scholarship, education and health initiatives.",
  },
  prabhuTrust: {
    label: "Prabhu Premi Sangh Charitable Trust",
    url: "https://www.prabhupremisangh.org/web/pages/prabhu_premi_sangh_charitable_trust.html",
    note: "Service of humanity, rehabilitation, feeding the hungry, support for the poor and organized branches.",
  },
  agmIndia: {
    label: "NGO Details - AvdheshanandG Mission India",
    url: "https://ngodetails.com/india/delhi/avdheshanandg-mission/",
    note: "Public registration listing for AvdheshanandG Mission as a Delhi trust.",
  },
  agmUs: {
    label: "Org Council - AvdheshanandG Mission USA",
    url: "https://www.orgcouncil.com/ein/333180376",
    note: "Public U.S. listing describing AGM as a charitable and educational organization in Chatsworth, California.",
  },
  charityNavigator: {
    label: "Charity Navigator - AGM profile",
    url: "https://www.charitynavigator.org/ein/333180376",
    note: "U.S. nonprofit profile, EIN listing, and current not-rated status.",
  },
  ifsCsr: {
    label: "TheCSRUniverse - Institute of Future Skilling",
    url: "https://thecsruniverse.com/articles/ladli-foundation-and-swami-avdheshanand-giri-ji-maharaj-launch-institute-of-future-skilling-to-empower-2-000-youth-in-digital-technologies",
    note: "Launch coverage: 2,000 underprivileged youth, AI, digital marketing, web development, animation, design, cybersecurity and computer skills.",
  },
  ifsApn: {
    label: "APN News - IFS launch coverage",
    url: "https://www.apnnews.com/swami-avdheshanand-giri-unveils-the-institute-of-future-skilling-to-nurture-2000-youth-in-ai-and-digital-innovation/",
    note: "Additional reporting on IFS, inclusion, girls, transgender learners and launch participation.",
  },
  ladliIfsl: {
    label: "Ladli Foundation - IFSL infrastructure",
    url: "https://www.ladlifoundation.org/our-infrastructure/IFSL",
    note: "Program description: labs, mentorship, placement-linked training, scholarships and SDG alignment.",
  },
  shagunTravtalk: {
    label: "TravTalk - Shagun Vivah Utsav 2026",
    url: "https://travtalkindia.com/shagun-vivah-utsav-2026-organised-by-rashi-entertainment-ladli-foundation-hosts-51-couples-mass-wedding-in-delhi/",
    note: "Event coverage: 51 couples, March 30, 2026, The Zora Convention Centre, Delhi, dignitaries and ceremony details.",
  },
  shagunWeddingCompany: {
    label: "The Wedding Company - Shagun Vivah Utsav",
    url: "https://www.theweddingcompany.com/wedding/shagun-vivah-utsav-in-delhi",
    note: "Coverage naming Ladli Foundation and AvdheshanandG Mission and framing the event as dignity-first social protection.",
  },
  shagunMagzter: {
    label: "The Business Guardian via Magzter",
    url: "https://www.magzter.com/stories/newspaper/The-Business-Guardian/THE-WEDDING-COMPANY-JOINS-SHAGUN-VIVAH-UTSAV-2026-CELEBRATES-51-BRIDES-THROUGH-A-GRAND-MASS-WEDDING-INITIATIVE-IN-DELHI",
    note: "Additional public reporting on safe, dignified marriages, varmala, pheras, vidaai and dignitary attendance.",
  },
  mahakumbhHt: {
    label: "Hindustan Times - Yuva Kumbh at Mahakumbh",
    url: "https://www.hindustantimes.com/cities/others/tribal-youth-gather-for-yuva-kumbh-in-mahakumbh-nagar-101738867944989.html",
    note: "Coverage of Yuva Kumbh at Swami Avdheshanand Giri's pandal during Mahakumbh.",
  },
  mahakumbhClinic: {
    label: "Sanatan Prabhat - Prabhu Premi Sangh Shibir",
    url: "https://sanatanprabhat.org/english/128032.html",
    note: "Camp description including accommodation, food arrangements, security, offices and clinic.",
  },
  netraKumbh: {
    label: "Sanatan Prabhat - Netra Kumbh",
    url: "https://sanatanprabhat.org/english/123607.html",
    note: "Swami ji's remarks at the inauguration of an ophthalmology camp during Mahakumbh 2025.",
  },
  champawatListing: {
    label: "Justdial - Swami Avdheshanand Public School",
    url: "https://www.justdial.com/Champawat/Swami-Avdheshanand-Public-School-Birgul/9999P5965-5965-231216071413-M1I5_BZDET",
    note: "Public listing for Swami Avdheshanand Public School in Birgul, Champawat.",
  },
  champawatRoad: {
    label: "PWD Uttarakhand - Champawat road listing",
    url: "https://pwduk.in/im/RoadsList/Consituency/55",
    note: "Government road listing referencing the link road to Swami Avdheshanand Public School.",
  },
};

const blogSeeds = [
  {
    _id: "vedant-for-american-donors",
    title: "Vedant for American Donors: Why Seva Is More Than Charity",
    category: "USA",
    createdAt: "2026-04-24T10:00:00.000Z",
    readTime: "7 min read",
    audience: "USA supporters",
    deck:
      "For a USA supporter, AGM makes giving feel close to the field. Vedant reframes donation as participation in shared human dignity.",
    sourceLine: "Isha Upanishad 1, Bhagavad Gita 2.50, Bhagavad Gita 12.13",
    images: [
      "/assets/agm/hero-usa.jpg",
      "/assets/agm/mahakumbh-seva.jpg",
      "/assets/agm/polyclinic-consultation.jpg",
      "/assets/agm/web/swamiji-prabhu-premi.png",
    ],
    keyPoints: [
      "Seva is not pity; it is disciplined participation in another person's dignity.",
      "A USA donor needs clarity: where the money goes, what program it supports, and what change it creates.",
      "Vedant gives AGM a moral language for transparent, respectful social impact.",
    ],
    sections: [
      {
        heading: "The Vedantic shift",
        body: [
          "In ordinary charity, the donor may stand above the receiver. Vedant dissolves that distance. Isha Upanishad 1 begins with a sacred view of the whole: everything is pervaded by the divine reality. That vision changes the posture of giving.",
          "A donor is not merely transferring funds. A donor is joining a field of responsibility where another family's health, education, dignity or safety matters as one's own.",
        ],
      },
      {
        heading: "Why this matters for AGM",
        image: "/assets/agm/mahakumbh-seva.jpg",
        body: [
          "Public listings show AvdheshanandG Mission in two important geographies: the India trust listing in Delhi and the U.S. charitable organization listing in Chatsworth, California. AGM therefore communicates as both a field mission in India and a bridge for global supporters.",
          "AGM's work across healthcare, skilling, education, relief seva and women dignity needs to be presented with the seriousness American donors expect from a modern nonprofit: program clarity, source-backed storytelling, receipts of impact and a clean giving journey.",
          "The Vedantic foundation makes the mission emotionally deep; clear reporting, program pages, annual reports and audited proof make it credible.",
        ],
      },
      {
        heading: "What to take home",
        body: [
          "Before giving, ask whether the program protects dignity. Before volunteering, ask whether the action is skilled. Before judging impact, ask whether the work can be explained to a donor and felt by a beneficiary.",
        ],
      },
    ],
    takeaways: [
      "Give with humility, not superiority.",
      "Ask for program clarity and impact reporting.",
      "Let Vedant become a habit of responsible generosity.",
    ],
    tags: ["USA", "Vedant", "Donation", "Seva"],
    sourceLinks: [sources.prabhuLife, sources.prabhuTrust, sources.agmIndia, sources.agmUs, sources.charityNavigator],
  },
  {
    _id: "adi-shankaracharya-and-agm",
    title: "Adi Shankaracharya and AGM: Turning Non-Dual Wisdom Into Public Good",
    category: "Vedant",
    createdAt: "2026-04-22T10:00:00.000Z",
    readTime: "8 min read",
    audience: "Global readers",
    deck:
      "Vedant is incomplete without Adi Shankaracharya. AGM carries that clarity into organized public service.",
    sourceLine: "Upanishads, Bhagavad Gita, Brahma Sutra, Prasthana Trayi lineage",
    images: [
      "/assets/agm/swamiji-vedant.jpg",
      "/assets/agm/champawat-school.jpg",
      "/assets/agm/polyclinic.jpg",
      "/assets/agm/web/swamiji-prabhu-premi.png",
    ],
    keyPoints: [
      "Adi Shankaracharya gave Advaita Vedant a disciplined interpretive spine.",
      "A modern NGO needs the same discipline: clear programs, clear ethics, clear reporting.",
      "Swami ji's inspiration can help AGM convert non-dual vision into organized compassion.",
    ],
    sections: [
      {
        heading: "Why Shankaracharya belongs at the center",
        body: [
          "The Prasthana Trayi tradition centers the Upanishads, Bhagavad Gita and Brahma Sutra. Adi Shankaracharya's commentarial lineage gave Advaita Vedant a precise way to inquire into Brahman, Atman and the non-dual truth.",
          "Swami ji's public biography also identifies him as a Vedantic scholar who follows the Advaita Vedanta tradition. That matters because AGM treats Vedant as disciplined insight that becomes disciplined service.",
          "Without that discipline, Vedant can become a decorative word. With it, Vedant becomes a way to see clearly and act responsibly.",
        ],
      },
      {
        heading: "From clarity to institution",
        image: "/assets/agm/champawat-school.jpg",
        body: [
          "A school, clinic or skilling center also needs clarity. Who is served? What is delivered? What changes in the beneficiary's life? This is the NGO version of disciplined inquiry.",
          "AGM stands as a social-impact institution rooted in Vedantic clarity and practical service.",
        ],
      },
      {
        heading: "The living bridge",
        body: [
          "Swami ji becomes the living bridge between source wisdom and public service. AGM becomes the vehicle that lets people participate in that wisdom through donations, volunteering and program building.",
        ],
      },
    ],
    takeaways: [
      "Respect source tradition.",
      "Do not reduce Vedant to mood or aesthetic.",
      "Build institutions with the same discipline used for inquiry.",
    ],
    tags: ["Adi Shankaracharya", "Vedant", "AGM", "NGO"],
    sourceLinks: [sources.prabhuLife, sources.prabhuTrust],
  },
  {
    _id: "gita-framework-for-volunteering",
    title: "From Samatvam to Service: A Bhagavad Gita Framework for Volunteering",
    category: "Vedant",
    createdAt: "2026-04-20T10:00:00.000Z",
    readTime: "6 min read",
    audience: "USA volunteers",
    deck:
      "The Gita offers a practical volunteer ethic: steadiness, skill, compassion and work for the holding together of society.",
    sourceLine: "Bhagavad Gita 2.48, 2.50, 3.20-25, 12.13",
    images: [
      "/assets/agm/mahakumbh-seva.jpg",
      "/assets/agm/mahakumbh-medical.jpg",
      "/assets/agm/ifs-students.jpg",
      "/assets/agm/web/swamiji-prabhu-premi.png",
    ],
    keyPoints: [
      "Samatvam means staying balanced before action.",
      "Karmasu kaushalam means service is skilled, planned and reliable.",
      "Lokasangraha makes volunteering a public responsibility, not a weekend mood.",
    ],
    sections: [
      {
        heading: "Equanimity before action",
        body: [
          "Bhagavad Gita 2.48 calls equanimity yoga. For a volunteer, this means arriving without panic, superiority or the need to be praised.",
          "In an AGM setting, the calm volunteer becomes useful: they can register patients, guide families, teach a class, document impact or support a relief camp without creating noise around themselves.",
        ],
      },
      {
        heading: "Skill is also spiritual",
        image: "/assets/agm/mahakumbh-medical.jpg",
        body: [
          "Bhagavad Gita 2.50 says yoga is skill in action. That verse belongs in every NGO operations room.",
          "If a medical camp is disorganized, compassion suffers. If a skilling class is irregular, confidence breaks. If donor records are unclear, trust weakens.",
          "Prabhu Premi Sangh's own charitable description uses this same grammar in public service: service of humanity, rehabilitation of the destitute, feeding the hungry and support for the poor. AGM's volunteer culture continues that seriousness.",
        ],
      },
      {
        heading: "A USA volunteer's role",
        body: [
          "A USA supporter may help with fundraising, content, digital systems, professional mentorship, curriculum, reporting or donor stewardship. Each can become seva when done with steadiness and skill.",
        ],
      },
    ],
    takeaways: [
      "Do fewer things, but do them reliably.",
      "Serve with calmness and competence.",
      "Make your skill useful to someone beyond your own circle.",
    ],
    tags: ["USA", "Volunteer", "Bhagavad Gita", "Seva"],
    sourceLinks: [sources.prabhuTrust, sources.prabhuLife],
  },
  {
    _id: "future-skilling-as-vedant",
    title: "Future Skilling as Vedant: Coding, Design and Dignity for the Next Generation",
    category: "Education",
    createdAt: "2026-04-18T10:00:00.000Z",
    readTime: "7 min read",
    audience: "Parents, donors and mentors",
    deck:
      "Modern tools can become a Vedantic intervention when they are taught with character, confidence and self-respect.",
    sourceLine: "Mundaka Upanishad 1.1.4-5",
    images: [
      "/assets/agm/web/ifs-launch-apn.jpg",
      "/assets/agm/web/ifsl-lab-0.webp",
      "/assets/agm/web/ifsl-lab-3.webp",
      "/assets/agm/web/ifsl-lab-5.webp",
      "/assets/agm/ifs-lab.jpg",
      "/assets/agm/ifs-students.jpg",
      "/assets/agm/champawat-school.jpg",
    ],
    keyPoints: [
      "Mundaka Upanishad distinguishes lower knowledge and higher knowledge.",
      "Coding, design, editing and Tally open livelihood pathways.",
      "Vedant keeps skill from becoming only ambition; it adds responsibility and self-knowledge.",
    ],
    sections: [
      {
        heading: "Apara vidya and employability",
        body: [
          "The Mundaka Upanishad's distinction between apara vidya and para vidya gives AGM a powerful education model.",
          "Apara vidya includes the practical knowledge needed to function in the world. Today that includes coding, graphic design, video editing, Tally, AI tools and professional communication.",
        ],
      },
      {
        heading: "The Institute of Future Skilling",
        image: "/assets/agm/web/ifs-launch-apn.jpg",
        body: [
          "Public CSR coverage reports that the Institute of Future Skilling was launched in Chhatarpur, New Delhi through Ladli Foundation's partnership with Swami Avdheshanand Giri Ji Maharaj and Avdheshanandji Mission, with IACT as training partner.",
          "The launch coverage describes a target of 2,000 underprivileged youth, especially girls and members of the transgender community, with free training in AI, digital marketing, web development, animation, graphic designing, cyber security and advanced computer skills.",
          "IFS is a bridge between underserved youth and modern opportunity. Its deeper promise is not only job placement. When a young person learns a tool and also learns discipline, dignity and self-trust, the training becomes social transformation.",
        ],
      },
      {
        heading: "What the lab model shows",
        image: "/assets/agm/web/ifsl-lab-3.webp",
        body: [
          "Ladli Foundation's IFSL infrastructure page describes advanced computer labs, career-readiness zones, mentorship corners, digital access spaces, project-based innovation labs and placement-linked training.",
          "That gives AGM a strong skilling story: workstations, student portfolios, mentor reviews, certification paths, placement readiness and confidence building.",
        ],
      },
      {
        heading: "How USA mentors can help",
        body: [
          "USA professionals can mentor students remotely, review portfolios, support English communication, sponsor lab equipment or help build job-linked curriculum.",
        ],
      },
    ],
    takeaways: [
      "Skill is dignity when it opens a real future.",
      "Mentorship can travel across countries.",
      "Technology uplifts when it builds confidence and opportunity.",
    ],
    tags: ["USA", "Education", "Future Skilling", "Youth"],
    sourceLinks: [sources.ifsCsr, sources.ifsApn, sources.ladliIfsl],
  },
  {
    _id: "polyclinic-as-equal-vision",
    title: "The Polyclinic as Equal Vision: Healthcare Through the Lens of Vedant",
    category: "Healthcare",
    createdAt: "2026-04-16T10:00:00.000Z",
    readTime: "6 min read",
    audience: "Healthcare donors",
    deck:
      "When Vedant says the Self is seen in all beings, healthcare becomes more than a service line. It becomes dignity in action.",
    sourceLine: "Bhagavad Gita 5.18 and 6.29",
    images: [
      "/assets/agm/polyclinic.jpg",
      "/assets/agm/polyclinic-consultation.jpg",
      "/assets/agm/mahakumbh-medical.jpg",
    ],
    keyPoints: [
      "Equal vision must be visible in waiting rooms, medicine access and patient communication.",
      "A clinic is a frontline expression of Vedantic dignity.",
      "USA healthcare supporters can help with systems, sponsorships, equipment and medical networks.",
    ],
    sections: [
      {
        heading: "Dignity begins at the point of care",
        body: [
          "Bhagavad Gita 5.18 speaks of equal vision. In healthcare, equal vision is practical. It means the poor patient is not rushed, ignored or treated as a burden.",
          "Swami ji's public life sketch specifically mentions health initiatives such as mobile dispensaries and health clinics launched through his inspiration. Swami Avdheshanand Polyclinic stands in that lineage of practical compassion.",
          "The polyclinic embodies Vedant through accessible consultation, respectful patient flow and medicines for families who cannot absorb private healthcare costs.",
        ],
      },
      {
        heading: "From patient to person",
        image: "/assets/agm/polyclinic-consultation.jpg",
        body: [
          "The best NGO healthcare pages do not only show facilities. They show the human experience: a doctor listening, a family relieved, a patient receiving care without humiliation.",
          "This is where Vedant matters. The patient is not an entry in a register. The patient is a person carrying the same Self.",
        ],
      },
      {
        heading: "How supporters can participate",
        body: [
          "Supporters can fund medicines, diagnostic camps, specialist visits, patient record systems, preventive health education and mobile outreach.",
        ],
      },
    ],
    takeaways: [
      "Healthcare impact is measured in both outcomes and dignity.",
      "A clinic needs systems as much as compassion.",
      "Equal vision is felt by the patient.",
    ],
    tags: ["Healthcare", "Vedant", "Polyclinic", "USA"],
    sourceLinks: [sources.prabhuLife, sources.prabhuTrust],
  },
  {
    _id: "shagun-vivah-dignity",
    title: "Shagun Vivah Utsav 2026: Dignity, Not Dowry, as a Vedantic Social Statement",
    category: "Women dignity",
    createdAt: "2026-04-14T10:00:00.000Z",
    readTime: "7 min read",
    audience: "Families and donors",
    deck:
      "The 51-couple celebration at The Zora Convention Centre shows how Vedantic equal vision can become a public stand for dignity.",
    sourceLine: "Bhagavad Gita 5.18, Isha Upanishad 1",
    images: [
      "/assets/agm/web/shagun-vivah-travtalk.jpeg",
      "/assets/agm/mass-wedding-ceremony.jpg",
      "/assets/agm/mass-wedding-dignitaries.jpg",
      "/assets/agm/mass-wedding-shagun-hero.png",
    ],
    keyPoints: [
      "A dignity-first wedding is a social-protection intervention, not a spectacle.",
      "The event supported 51 couples with blessings, essentials and public honor.",
      "AGM's role centers women’s dignity and family stability.",
    ],
    sections: [
      {
        heading: "Equal vision at a wedding mandap",
        body: [
          "If equal vision is real, a wedding for an economically vulnerable family does not feel lesser. It carries honor, beauty and public blessing.",
          "Public coverage reports that Shagun Vivah Utsav 2026 brought together 51 couples on March 30, 2026 at The Zora Convention Centre, JLN Stadium, New Delhi. The event was held under the divine blessings of Swami Avdheshanand Giri and attended by national and Delhi leadership, senior officers and dignitaries.",
          "Shagun Vivah Utsav 2026 made dignity visible by placing economically vulnerable couples inside a grand, organized and socially honored setting.",
        ],
      },
      {
        heading: "AGM's NGO lens",
        image: "/assets/agm/web/shagun-vivah-travtalk.jpeg",
        body: [
          "The Wedding Company's coverage names Ladli Foundation and AvdheshanandG Mission together and frames the initiative as safe, dignified marriages for women from economically vulnerable backgrounds, with rejection of dowry and post-marriage support.",
          "For AGM, Shagun Vivah Utsav is more than an event. It is a women’s dignity program with financial support, household essentials, civil-society collaboration and social confidence.",
          "USA audiences understand dignity when it is connected to stability, family systems, safety verification, opportunity and measurable protection from debt.",
        ],
      },
      {
        heading: "What the event teaches",
        body: [
          "Vedant does not remove social responsibility. It deepens it. If the same Self is present in all, then public rituals do not humiliate the poor or celebrate inequality.",
        ],
      },
    ],
    takeaways: [
      "Dignity is a program outcome.",
      "Celebration can also be social protection.",
      "A family begins with confidence, not debt.",
    ],
    tags: ["Women dignity", "Mass Wedding", "Shagun Vivah", "Vedant"],
    sourceLinks: [sources.shagunTravtalk, sources.shagunWeddingCompany, sources.shagunMagzter],
  },
  {
    _id: "mahakumbh-seva-lokasangraha",
    title: "Mahakumbh Seva and Lokasangraha: Holding Society Together at Massive Scale",
    category: "Relief",
    createdAt: "2026-04-12T10:00:00.000Z",
    readTime: "6 min read",
    audience: "Global Hindu diaspora",
    deck:
      "Mahakumbh seva shows what happens when spiritual gathering meets food, transport, shelter and medical relief.",
    sourceLine: "Bhagavad Gita 3.20-25",
    images: [
      "/assets/agm/mahakumbh-satsang.jpg",
      "/assets/agm/mahakumbh-medical.jpg",
      "/assets/agm/mahakumbh-seva.jpg",
    ],
    keyPoints: [
      "Lokasangraha means action for the stability and welfare of the world.",
      "Mass gatherings require systems: food, shelter, medical care and transport support.",
      "AGM's Mahakumbh story shows scale, compassion and operational competence.",
    ],
    sections: [
      {
        heading: "A spiritual gathering is also a human system",
        body: [
          "Mahakumbh is sacred, but it is also immense. Pilgrims need food, medical support, shelter, warmth, directions and safe movement.",
          "Bhagavad Gita's idea of lokasangraha gives a powerful lens: action that holds society together.",
          "Public Mahakumbh coverage around Swami ji's camp shows how spiritual leadership also becomes large-scale coordination: pandals, discourse spaces, accommodations, food systems, offices and clinics working together for thousands of visitors.",
        ],
      },
      {
        heading: "What AGM documents",
        image: "/assets/agm/mahakumbh-medical.jpg",
        body: [
          "The Mahakumbh seva record is strongest when it connects meals served, patients treated, blankets distributed, camps organized and transport support delivered with the field systems behind them.",
          "For global audiences, this is where faith becomes legible as humanitarian logistics. Mahakumbh is not only spectacle; it is a test of seva capacity.",
        ],
      },
      {
        heading: "The lesson for every reader",
        body: [
          "When society gathers, seva must scale. Devotion is not only in worship. It is also in planning a camp, stocking medicine and helping a stranger reach safety.",
        ],
      },
    ],
    takeaways: [
      "Large spiritual events need humanitarian infrastructure.",
      "Relief seva is planned before it is emotional.",
      "Faith is strongest when it protects people.",
    ],
    tags: ["Mahakumbh", "Relief", "Lokasangraha", "USA"],
    sourceLinks: [sources.mahakumbhHt, sources.mahakumbhClinic, sources.netraKumbh],
  },
  {
    _id: "champawat-school-character",
    title: "Champawat School: Where Education, Character and Rural Aspiration Meet",
    category: "Education",
    createdAt: "2026-04-10T10:00:00.000Z",
    readTime: "5 min read",
    audience: "Education supporters",
    deck:
      "Swami Avdheshanand Public School represents values-led rural education with digital exposure and confidence.",
    sourceLine: "Taittiriya Upanishad 1.11, Mundaka Upanishad 1.1.4-5",
    images: [
      "/assets/agm/champawat-school.jpg",
      "/assets/agm/ifs-lab.jpg",
      "/assets/agm/ifs-students.jpg",
    ],
    keyPoints: [
      "Education builds confidence, discipline and aspiration.",
      "Rural students need values and digital exposure together.",
      "USA supporters can fund classrooms, labs, scholarships and teacher development.",
    ],
    sections: [
      {
        heading: "Education beyond marks",
        body: [
          "A school is not only a place for exams. In a Vedantic framework, education helps a child develop clarity, restraint, courage and respect.",
          "Public listings place Swami Avdheshanand Public School in Birgul, Champawat, and a Uttarakhand PWD road list references a link road to the school. This may sound small, but for rural education it is not small. Connectivity is part of opportunity.",
          "Champawat's school story is one of rural aspiration: children gaining language, confidence, discipline, digital readiness and physical access to an institution their families can trust.",
        ],
      },
      {
        heading: "The AGM opportunity",
        image: "/assets/agm/champawat-school.jpg",
        body: [
          "AGM strengthens a school identity that combines values with modern readiness: smart classrooms, computer access, libraries, sports, arts and mentorship.",
          "For donors, the most compelling education story is not infrastructure alone; it is a child's expanded horizon.",
        ],
      },
      {
        heading: "What supporters can do",
        body: [
          "Supporters can sponsor books, devices, classroom improvements, teacher training, scholarships and exposure visits.",
        ],
      },
    ],
    takeaways: [
      "Education increases both skill and self-belief.",
      "Rural aspiration deserves modern tools.",
      "Values and employability belong together.",
    ],
    tags: ["Education", "Champawat", "School", "USA"],
    sourceLinks: [sources.champawatListing, sources.champawatRoad, sources.prabhuLife],
  },
  {
    _id: "usa-india-bridge",
    title: "The USA-India Seva Bridge: How Diaspora Support Can Build Long-Term Impact",
    category: "USA",
    createdAt: "2026-04-08T10:00:00.000Z",
    readTime: "7 min read",
    audience: "USA diaspora",
    deck:
      "The strongest USA-India giving model is not occasional emotion. It is a reliable bridge of donors, mentors, volunteers and transparent reporting.",
    sourceLine: "Isha Upanishad 1, Bhagavad Gita 3.20-25",
    images: [
      "/assets/agm/hero-usa.jpg",
      "/assets/agm/hero-india.jpg",
      "/assets/agm/ifs-students.jpg",
    ],
    keyPoints: [
      "USA supporters need a clear giving journey and region-aware donation experience.",
      "Diaspora seva can include mentorship, technology, fundraising and governance support.",
      "AGM makes cross-border participation simple and transparent.",
    ],
    sections: [
      {
        heading: "From emotion to stewardship",
        body: [
          "Diaspora giving often begins with emotion: a memory of India, reverence for a teacher, or a desire to support dharmic work. AGM deepens that emotion into stewardship.",
          "Stewardship means regular communication, clear campaigns, proof of impact and an invitation to contribute skills, not only funds.",
        ],
      },
      {
        heading: "What a USA supporter sees",
        image: "/assets/agm/hero-usa.jpg",
        body: [
          "Public U.S. listings show AvdheshanandG Mission as a charitable and educational organization in Chatsworth, California, with IRS exempt status listed from February 2025. Charity Navigator also lists the organization but currently marks it not rated because newer nonprofits may not yet have the filing history required for a star rating.",
          "A USA supporter sees a region-aware donation path, program clarity, annual reports, field images, source-backed stories and a transparent explanation of what has been built so far.",
          "They also see how Vedant shapes the ethics of the mission: dignity, equal vision, disciplined action and public welfare.",
        ],
      },
      {
        heading: "The bridge model",
        body: [
          "The bridge can include monthly donors, professional mentors, medical advisors, technology volunteers, content contributors, university chapters and family giving circles.",
        ],
      },
    ],
    takeaways: [
      "Make giving recurring, not random.",
      "Offer skill as well as money.",
      "Ask for transparent updates and measurable outcomes.",
    ],
    tags: ["USA", "Diaspora", "Donors", "Transparency"],
    sourceLinks: [sources.agmUs, sources.charityNavigator, sources.agmIndia, sources.prabhuLife],
  },
];

function buildBlogContent(blog) {
  const points = blog.keyPoints.map((point) => `<li>${point}</li>`).join("");
  const sections = blog.sections
    .map(
      (section) => `
        <section>
          <h2>${section.heading}</h2>
          ${
            section.image
              ? `<figure><img src="${section.image}" alt="${section.heading}" /><figcaption>${section.heading}</figcaption></figure>`
              : ""
          }
          ${section.body.map((paragraph) => `<p>${paragraph}</p>`).join("")}
        </section>
      `
    )
    .join("");
  const takeaways = blog.takeaways.map((item) => `<li>${item}</li>`).join("");

  return `
    <p>${blog.deck}</p>
    <h2>Key points</h2>
    <ul>${points}</ul>
    ${sections}
    <h2>Take-home practices</h2>
    <ul>${takeaways}</ul>
  `;
}

export const fallbackBlogs = blogSeeds.map((blog) => ({
  ...blog,
  author: editorialAuthor,
  content: buildBlogContent(blog),
}));

export function getFallbackBlog(id) {
  return fallbackBlogs.find((blog) => blog._id === id);
}
